<template>

    <div class="group">

        <h2 class="heading_line _jp _alpha-down">
            <p><span>対象店舗</span></p>
            <div class="line"></div>
        </h2>

        <div class="form_radio-wrap _small">

            <div class="item form_radio" v-for="(net_shop,index) in net_shops" v-bind:key="index">
                <input type="radio" name="particular-net" class="" :id="'particular-net' + index" v-on:click="clickNetShop(net_shop)">
                <label :for="'particular-net' + index">
                    <span>{{ net_shop.name }}</span>
                </label>
            </div>

        </div><!--/.item-wrap-->

    </div><!--/セールス募集-->

</template>

<script>
    export default {
        data() {
            return {
                net_shops: [
                    { id: 0, name: '実店舗・ECサイト両方可' },
                    { id: 1, name: '実店舗のみ可' },
                    { id: 2, name: 'ECサイトのみ可' },
                    { id: 3, name: 'POPUPのみ可'},
                    { id: 4, name: '卸無し'},
                ]
            }
        },
        methods: {
            clickNetShop(net_shop) {
                this.$store.state.search.form.net_shop = net_shop;
            }
        }
    }
</script>
